import { render, staticRenderFns } from "./GeographyCargoTransportationSimpleBlock.vue?vue&type=template&id=0d1c8c58&scoped=true&"
import script from "./GeographyCargoTransportationSimpleBlock.vue?vue&type=script&lang=js&"
export * from "./GeographyCargoTransportationSimpleBlock.vue?vue&type=script&lang=js&"
import style0 from "./GeographyCargoTransportationSimpleBlock.vue?vue&type=style&index=0&id=0d1c8c58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c8c58",
  null
  
)

export default component.exports